import React, { useEffect, useState } from 'react';
import { Button, Modal, Checkbox, Form, Input, Select, Collapse, Row, Col } from 'antd';
import { DatePicker } from "antd";
import InputNumber from "components/input-number"
import VoucherService from 'services/voucher';
import { useApp } from 'contexts/app';
import dayjs from "dayjs"
const { Option } = Select;
const { Panel } = Collapse;
const service = new VoucherService();
const VoucherModal = ({ open, onClose, id, onSaved }) => {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const { showLoading, showNotify } = useApp();
    const [form] = Form.useForm();
    const [voucher, setVoucher] = useState({});
    const showModal = () => {
        setIsModalOpen(true);
    };
    const handleOk = () => {
        form.submit()
        //onClick={() => form.submit()}
        //  setIsModalOpen(false);
    };
    const handleCancel = () => {
        setIsModalOpen(false);
        onClose();
    };
    useEffect(() => {
        setIsModalOpen(open);
        loadData();
    }, [open])
    useEffect(() => {
        form.setFieldsValue(voucher)
    }, [voucher])

    const loadData = async () => {
        if (!id) {
            setVoucher({ id: null, code: "", description: "", type: "fixed", value: 10000, usage_limit: 1 })
        } else {
            var voucher = await service.get(id);
            setVoucher(voucher);
        }
    }

    const onFinish = async values => {
  
       

        showLoading(true);
        try {
            var voucher = await service.create(values);
            setVoucher(voucher);
            showNotify(`Voucher ${voucher.code} đã được tạo`);
            if(onSaved){
                onSaved(voucher);
            }
        } catch (error) {
            console.log("error", error)
        }

        showLoading(false);
        //console.log('Success:', values);
    };
    const onFinishFailed = errorInfo => {
        // console.log('Failed:', errorInfo);
    };

    const copy = async text => {
        await window.navigator.clipboard.writeText(text);
        showNotify(`Đã copy ${text}`)
    }
    return (
        <>

            <Modal title="Thêm voucher" open={isModalOpen} onOk={handleOk} onCancel={handleCancel}>
                <Form
                    name="basic"
                    labelCol={{ span: 8 }}
                    wrapperCol={{ span: 16 }}
                    style={{ maxWidth: 600 }}
                    initialValues={{ remember: true }}
                    onFinish={onFinish}
                    onFinishFailed={onFinishFailed}
                    autoComplete="off"
                    form={form}
                    layout='vertical'
                >

                    <Form.Item

                        name="id"
                        hidden

                    >

                    </Form.Item>
                    <Form.Item
                        label="Mã"
                        name="code"


                    >
                        {/* <Input addonAfter={<Button type='link' size='small'>Tạo mã</Button>} /> */}
                        <Input disabled={voucher.id} addonAfter={voucher.id?<Button size='small' onClick={e=>copy(voucher.code)}>Copy</Button>:null} />
                    </Form.Item>



                    <Form.Item
                        label="Mô Tả"
                        name="description"
                        rules={[{ message: 'Please input voucher description!' }]}>
                        <Input />
                    </Form.Item>
                    <Form.Item name="type" label="Loại Voucher" rules={[{ required: true }]}>
                        <Select>
                            <Option value="fixed">Giảm số tiền cố định</Option>
                            <Option value="percentage">Giảm theo %</Option>

                            {/* <Option value="free_shipping">Miễn phí vận chuyển</Option> */}
                            {/* <Option value="gift">Tặng quà</Option> */}
                        </Select>
                    </Form.Item>

                    <Form.Item
                        label="Giá trị"
                        name="value"
                        rules={[{ required: true, message: 'Please input voucher amount!' }]}>
                        <InputNumber style={{ width: 300 }} />
                    </Form.Item>

                    <Form.Item
                        label="Số lần dùng"
                        name={"usage_limit"}
                        rules={[{ required: true, message: 'Please input voucher usage_limit!' }]}>
                        <InputNumber style={{ width: 300 }} showCalculator={false} />
                    </Form.Item>



                    <Form.Item

                        name={["limit", "time", "is_limit"]}
                        valuePropName="checked"
                        noStyle
                    >
                        <Checkbox>Giới hạn thời gian</Checkbox>
                    </Form.Item>

                    <Row >
                        <Col span={12}>
                            <Form.Item
                                label="Ngày bắt đầu"
                                name={["limit", "time", "start"]}
                                getValueProps={(value) => ({ value: value ? dayjs(value) : "", })}
                            >
                                <DatePicker />
                            </Form.Item>

                        </Col>
                        <Col span={12}>
                            <Form.Item
                                label="Ngày kết thúc"
                                name={["limit", "time", "end"]}
                                getValueProps={(value) => ({ value: value ? dayjs(value) : "", })}

                            >
                                <DatePicker />
                            </Form.Item>

                        </Col>
                    </Row>




                    {/* 
                    <Form.Item name="max_discount" label="Giảm tối đa (nếu có)">
                        <InputNumber addonAfter="VNĐ" min={0} style={{ width: "100%" }} showCalculator={false} />
                    </Form.Item> */}
                    {/* 
                    <Collapse ghost>
                        <Panel header="🎯 Điều kiện nâng cao" key="1">
                            <Form.Item label="Chọn SKU áp dụng" name="applicable_products">
                                <Select mode="tags" placeholder="Nhập SKU hoặc tên sản phẩm..." />
                            </Form.Item>

                            <Form.Item label="Khu vực áp dụng" name="region">
                                <Select mode="multiple" placeholder="Chọn khu vực">
                                    <Option value="north">Miền Bắc</Option>
                                    <Option value="south">Miền Nam</Option>
                                    <Option value="central">Miền Trung</Option>
                                </Select>
                            </Form.Item>

                      
                        </Panel>
                    </Collapse> */}


                    {/* <Form.Item name="condition" valuePropName="checked" label={null}>
                        <Checkbox>Remember me</Checkbox>
                    </Form.Item> */}

                </Form>
            </Modal>
        </>
    );
};
export default VoucherModal;